import {Component, EventEmitter, OnInit, Output, ViewChild, inject} from '@angular/core';
import { IgxCheckboxComponent, IgxCheckboxModule } from '@infragistics/igniteui-angular/checkbox';
import { IGX_DIALOG_DIRECTIVES, IgxDialogComponent, IgxDialogModule } from '@infragistics/igniteui-angular/dialog';
import { IgxButtonDirective, IgxButtonModule, IgxLayoutModule, IgxRippleModule } from '@infragistics/igniteui-angular/directives';
import { IgxIconComponent } from '@infragistics/igniteui-angular/icon';
import { IGX_NAVBAR_DIRECTIVES, IgxNavbarModule } from '@infragistics/igniteui-angular/navbar';
import {AppPresupuestosService} from '../../../../core/services/app-presupuestos.service';
import {TranslateModule} from '@ngx-translate/core';
import {ClsConfig} from "../../../../util/cls-config";

@Component({
  selector: 'app-envio-intercambio',
  templateUrl: './envio-intercambio.component.html',
  styleUrls: ['./envio-intercambio.component.scss'],
  imports: [
    IgxDialogModule,
    IGX_DIALOG_DIRECTIVES,
    IgxButtonModule,
    IgxButtonDirective,
    IgxRippleModule,
    IgxIconComponent,
    IgxNavbarModule,
    IGX_NAVBAR_DIRECTIVES,
    IgxLayoutModule,
    TranslateModule,
    IgxCheckboxModule,
    IgxCheckboxComponent
  ]
})
export class EnvioIntercambioComponent extends ClsConfig implements OnInit {
  private infPpto = inject(AppPresupuestosService);

  @ViewChild('mensajeIntercambioDialog', {static: true})
  public mensajeIntercambioDialog: IgxDialogComponent;

  @Output()
  public respuesta: EventEmitter<boolean> = new EventEmitter<boolean>();

  public alertMensaje: string;
  public formaQuestion: boolean;
  public siHayDatosRespaldar: boolean;

  constructor() {
    super();
  }

  ngOnInit(): void {
  }

  open() {
    this.infPpto.shortcut.find(value => value.Ventana === 'EnvioArchivoIntercambio').Abierto = false;
    this.mensajeIntercambioDialog.open();
  }

  close() {
    this.infPpto.shortcut.find(value => value.Ventana === 'EnvioArchivoIntercambio').Abierto = false;
    this.mensajeIntercambioDialog.close();
  }

  public cerrarVentana(chkDescargar: IgxCheckboxComponent) {
    this.close();
    this.respuesta.emit(chkDescargar.checked);
  }
}
